<template>
	<div class="month-select">
		<b-button slot="button" type="is-success" :disabled="isMonthPreviousButtonDisable" @click="onMonthPreviousButtonClick"><b-icon icon="chevron-left" size="is-medium"></b-icon></b-button>
		<b-select v-model="year" @input="onYearSelectChange">
			<option
				v-for="n in years"
				:value="n"
				:key="n">
				{{ n }}
			</option>
		</b-select>
		<p class="suffix">年</p>
		<b-select v-model="month" @input="onMonthSelectChange">
			<option
				v-for="n in months"
				:value="n"
				:key="n">
				{{ n }}
			</option>
		</b-select>
		<p class="suffix">月</p>
		<b-button type="is-success" :disabled="isMonthNextButtonDisable" @click="onMonthNextButtonClick"><b-icon icon="chevron-right" size="is-medium"></b-icon></b-button>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'month-selector',
	data() {
		return {
			years: [],
			months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
			year: '',
			month: '',
			endYear: null,
			startYear: 2019,
		}
	},
	created() {
		this.year = moment().format('YYYY').toString();
		this.endYear = parseInt(moment().format('YYYY')) + 1;
		for (let i = this.startYear; i <= this.endYear; i++) {
			this.years.push(i);
		}
		this.month = moment().format('M').toString();
	},
	mounted() {
	},
	computed: {
		isMonthPreviousButtonDisable: function() {
			// シフト範囲可能年月より前は選択不可
			let month = this.getCurrentMonth().add(-1, 'months');
			let start = this.getMonth(this.startYear, 1);
			return month < start ? true : false
		},
		isMonthNextButtonDisable: function() {
			// シフト範囲可能年月より後は選択不可
			let month = this.getCurrentMonth().add(1, 'months');
			let end = this.getMonth(this.endYear, 12);
			return month > end ? true : false
		},
	},
	methods: {
		getMonth: function(year, month) {
			return moment(`${year}-${this.$utils.zeroPadding(month, 2)}-01`);
		},
		getCurrentMonth: function() {
			return this.getMonth(this.year, this.month);
		},
		onYearSelectChange: function() {
			this.$emit('change-year', this,year);
		},
		onMonthSelectChange: function() {
			this.$emit('change-month', this.month);
		},
		onMonthPreviousButtonClick: function() {
			let month = this.getMonth(this.year, this.month).add(-1, 'months');
			this.year = month.format('YYYY');
			this.month = month.format('M');
			this.$emit('click-previous-month', this.year, this.month);
		},
		onMonthNextButtonClick: function() {
			let month = this.getMonth(this.year, this.month).add(1, 'months');
			this.year = month.format('YYYY');
			this.month = month.format('M');
			this.$emit('click-next-month', this.year, this.month);
		},
	},
}
</script>

<style scoped>
.month-select {
	display: flex;
	align-items: center;
}
.month-select .suffix {
	font-size: 18px;
	margin-right: 20px;
}
.month-select > button {
	margin-right: 20px;
}

</style>
